import React, { useEffect } from 'react';
import { licitacionesVigentes } from '../../json/licitacionesVigentes';
import { procedimientosHistoricos } from '../../json/procedimientosHistorico.js';
import styles from '../../styles/procedures.module.css';

const Licitaciones = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container transparencia-container'>
            <div className='row'>
                <div className='col_12'>
                    <div className='rubros_titulo'>
                        <h1>
                            Procedimientos de Contratación
                        </h1>
                    </div>
                </div>
                <div className={styles.cont}>
                    <h2>
                        Vigentes
                    </h2>
                    <hr className='hr-gob'></hr>
                    {licitacionesVigentes.length === 0 && (
                        <>
                            <div>
                                <h4 className={styles.withoutProcedures}>Sin procedimientos disponibles por el momento.</h4>
                            </div>
                        </>
                    )}
                    {
                        licitacionesVigentes.map((item, index) => (
                            <div key={ index }>
                                <h3 className={styles.title}>
                                    { item.numConvocatoria }
                                </h3>
                                <div className={styles.contTender}>
                                    <div className={styles.contTenderHeading}>
                                        <div className={styles.tenderName}>
                                            <p className={styles.tenderTextName}>
                                                { item.descripcionProcedimiento }
                                            </p>
                                        </div>
                                        <div className={styles.tenderDownload}>
                                            <a className={styles.tenderDownloadLink} href={ item.urlAnexos }>
                                                <p className={styles.tenderDownloadLinkText}>
                                                    Descargar
                                                </p>
                                                <i className={`${styles.tenderDownloadIcon} icon-file-zip`}></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div className={styles.contTenderData}>
                                        <div className={styles.tenderValidityBar}>
                                            <div className={styles.contDate}>
                                                <span>Vigencia de venta de bases: </span>
                                                <span className={styles.jumpDate}>
                                                    <br></br>
                                                </span>
                                                <div className={styles.inlineContent}>
                                                    <i className={`icon-calendar ${styles.barIcon}`}></i>
                                                    <span className={styles.date}>
                                                        {item.vigencia}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={styles.tenderValidity}>
                                            <p className={styles.textLine}>
                                                <span className={styles.tenderType}>
                                                    Tipo de procedimiento:
                                                </span>
                                                <span className={styles.jump}>
                                                    <br></br>
                                                </span>
                                                <span className={styles.additionalInfo}>
                                                    { item.procedimiento }.
                                                </span>
                                            </p>
                                            <p className={styles.textLine}>
                                                <span className={styles.tenderType}>
                                                    Num. de procedimiento:
                                                </span>
                                                <span className={styles.jump}>
                                                    <br></br>
                                                </span>
                                                <span className={styles.additionalInfo}>
                                                    { item.numProcedimiento }
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
                <h2>Histórico de procedimientos</h2>
                <hr className='hr-gob'></hr>
                <div className={styles.contHistory}>
                    {
                        procedimientosHistoricos.map((item, index) => (
                            <a key={ index } href={ item.url } className={styles.yearLink}>
                                <div className={styles.iconHistory}>
                                    <i className={ item.icoHistorico }></i>
                                </div>
                                <div className={styles.year}>
                                    <p className={styles.yearText}>
                                        { item.recurso }
                                    </p>
                                </div>
                            </a>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default Licitaciones